
import { computed, defineComponent, onMounted, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import axios from "@/axios-instance"
import Swal from "sweetalert2";
import { AzureKeyCredential, DocumentAnalysisClient } from "@azure/ai-form-recognizer";
import AddCustomerModal from "@/components/modals/forms/AddAdmissionsApplication.vue";
import Multiselect from "@vueform/multiselect";

import { PrebuiltIdDocumentModel } from "@/views/apps/prebuild/prebuilt-idDocument";
import DocumentIntelligence, {
  getLongRunningPoller,
  isUnexpected,
} from "@azure-rest/ai-document-intelligence";
import moment from "moment";
const key = '4ZaWQcYibfpmkYDMBbeZgPiICOagiG6gTwOJcerdtbbRs5v4uDcTJQQJ99BBACYeBjFXJ3w3AAALACOGm5CJ'
const endpoint = "https://docintellinstance.cognitiveservices.azure.com/"

function getTextOfSpans(content: string, spans: any): any {
  for (const span of spans) {
    content.slice(span.offset, span.offset + span.length);
  }
}
export default defineComponent({
  name: "modalRunAnalysis",
  emits:["callBackFunc"],
  props: {
    arrMajor: Array as any,
    id: String,
    title: String,
    priorityScore: [String, Number] as any
  },
  components: {
    AddCustomerModal,
    Multiselect,
  },
  methods: {
    updateData(data: any) {
    },
    triggerLocalPicker() {
      (this.$refs.localFileInput as any)?.click()
    },
    // Tải ảnh từ máy (dùng cho ứng viên chưa có hồ sơ) — thêm vào danh sách ảnh, phân tích bằng bytes
    onPickLocalFiles(e: any) {
      const files = Array.from(e?.target?.files || []) as any[]
      if (!files.length) return
      files.forEach((file: any) => {
        this.dataFiles.push({
          filePath: URL.createObjectURL(file),
          fileName: file.name,
          label: '',
          isLocal: true,
          file: file,
        })
      })
      const last = this.dataFiles[this.dataFiles.length - 1]
      this.imgActive = last.filePath
      this.tagAction = last.label
      this.imgActiveFile = last.file
      if (e?.target) e.target.value = '' // cho phép chọn lại cùng file
    },
    fileToBase64(file: any): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result).split(',')[1])
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    async onSelectTag(record) {
      // Ảnh local (chưa lưu vào hồ sơ) → chỉ cập nhật loại tại chỗ, không gọi API
      if (record.isLocal) {
        if (record.filePath == this.imgActive) this.tagAction = record.select
        return
      }
      let {data} = await axios.put(`/admission/file/${record.id}`,{
        label: record.select
      })
      if(data.filePath == this.imgActive) {
        this.tagAction = data.label
      }
    },
    async editAdmission(id) {
      // this.isEdit = true
      await axios.get(`/admission/register/${id}`)
      .then(( {data} ) => {
        data.adRegister.updatedAt = moment(data.adRegister.updatedAt).format('DD/MM/YYYY HH:mm')
        this.dataAdmissionRegister = data
        this.isCheckMajor = true
        if(data.adRegister.isArchived){
          this.isAppraised = data.adRegister.isArchived
        }
        else {
          this.isAppraised = data.adRegister.isAppraised
        }
      })
      .catch(({ response }) => {
      });
      // this.kt_modal_add_admissions_application?.click()
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async runAnalysisHOCBA() {
      this.popupLoading()
      try {
        const client = DocumentIntelligence(endpoint, { key: key });

      // Ảnh local → gửi bytes (base64Source); ảnh trong hồ sơ → gửi URL (urlSource)
      const analyzeBody: any = this.imgActiveFile
        ? { base64Source: await this.fileToBase64(this.imgActiveFile) }
        : { urlSource: this.imgActive };
      const initialResponse = await client
        .path("/documentModels/{modelId}:analyze", "prebuilt-layout")
        .post({
          contentType: "application/json",
          body: analyzeBody,
        });

      if (isUnexpected(initialResponse)) {
        throw new Error(initialResponse.body.error?.message || "Unexpected error");
      }
      const poller = getLongRunningPoller(client, initialResponse) as any
      const analyzeResult = (await poller.pollUntilDone()).body.analyzeResult as any
      
      const content: string | undefined = analyzeResult?.content;
      const pages = analyzeResult?.pages || [];
      const tables = analyzeResult?.tables || [];
      const languages = analyzeResult?.languages;

      if (pages.length === 0) {
      } else {
        for (const page of pages) {
        }
      }

      if (tables.length === 0) {
      } else {
        let dataTable = tables[0]?.cells?.filter((i: any,index: number) => index > 3 ) as any
        dataTable.forEach((item: any,index: number) => {
          if(item.columnIndex == 3) {
            let point = item.content
            let content = dataTable[index - 3]?.content
            let params = this.arrSubject[content]
            
            let temp = {
              [params]: point
            }
            if(params) {
              this.dataPoints = Object.assign(this.dataPoints,temp)
            }
          }
        })
      }

      // if (!languages || languages.length === 0) {
      //   console.log("No language spans were extracted from the document.");
      // } else {
      //   console.log("Languages:");
      //   for (const languageEntry of languages) {
      //     console.log(
      //       `- Found language: ${languageEntry.locale} (confidence: ${languageEntry.confidence})`
      //     );
      //     for (const text of getTextOfSpans(content || "", languageEntry.spans)) {
      //       const escapedText = text.replace(/\r?\n/g, "\\n").replace(/"/g, '\\"');
      //       console.log(`  - "${escapedText}"`);
      //     }
      //   }
      // }
      Swal.close()
      } catch (error) {
        Swal.fire({
              title: "Không thể quét được thông tin",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Trở lại",
              customClass: {
                  confirmButton: "btn btn-primary",
              },
          }).then(() => {
              //hideModal(addCustomerModalRef.value);
          });  
      }

    },
    async runAnalysis() {
      if(this.tagAction == 'hocba12') {
        this.runAnalysisHOCBA()
        return
      }
      else if(this.tagAction == 'cccdtruoc') {
        this.popupLoading()
      try {
        // Ảnh local → phân tích trực tiếp từ bytes (File là Blob); ảnh trong hồ sơ → từ URL
        const poller = this.imgActiveFile
          ? await this.client.beginAnalyzeDocument(PrebuiltIdDocumentModel, this.imgActiveFile)
          : await this.client.beginAnalyzeDocumentFromUrl(PrebuiltIdDocumentModel, this.imgActive);
        const result = await poller.pollUntilDone()
        if(result) {
          if(result.documents && result.documents.length != 0) {
            if(result.documents[0].fields && result.documents[0].fields.documentNumber) {
              let dataIDDoc = result.documents[0].fields as any
              let temp = {
                idCard: dataIDDoc.documentNumber?.content,
                fullName: `${dataIDDoc.lastName?.content} ${dataIDDoc.firstName?.content}`,
                dateOfBirth: new Date(dataIDDoc.dateOfBirth?.value)
              }
              this.formData = temp
            }
          }
        }
        // console.log('closeaaaaa',this.formData)
        Swal.close()
      } catch (error) {
          Swal.fire({
              title: "Không thể quét được thông tin",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Trở lại",
              customClass: {
                  confirmButton: "btn btn-primary",
              },
          }).then(() => {
              //hideModal(addCustomerModalRef.value);
          });   
      }
      }
      
      
    },
    async getAdFiles(id: any) {
      await axios.get(`/admission/register/${id}`)
        .then(async({ data }) => {
          this.dataAdm = data
          let files = data.adFiles.filter((i) => i.label == 'cccdtruoc')
          // console.log('files',data)
          this.dataFiles = data.adFiles
          if(data.adFiles && data.adFiles.length != 0) {
            this.imgActive = data.adFiles[0]?.filePath
            this.tagAction = data.adFiles[0]?.label
          }
          else {
            this.tagAction = null

            this.imgActive = null
          }

          
        })
        .catch((error) => {
        });
    },
    showModal() {
        this.call_modal_run_analysis.click()
    },
    closeModal(){
      hideModal(this.addRunAnalysis)
      // hideModal(this.addCustomerModalRef)
      this.admissionwinnerid = ''
      this.imgActive = ''
      this.imgActiveFile = null
      this.dataAdm = ''
      this.tagAction = ''
      this.isCheckMajor = false
      this.isAppraised = false
      this.dataPoints = {}
      this.dataFiles = []
    },
    async submitData() {
      this.$emit("callBackFunc",this.formData)
      this.closeModal()
    },
    async submitPointsData() {
      // Điểm học bạ phải áp vào 1 hồ sơ có sẵn — ảnh tải từ máy (chưa có hồ sơ) chỉ trích xuất, không áp được
      if (!this.admissionwinnerid || !this.dataAdm?.adDetails?.length) {
        Swal.fire({
          text: 'Điểm học bạ cần được áp dụng vào một hồ sơ. Vui lòng chọn hồ sơ có sẵn (ảnh tải từ máy chỉ để trích xuất, chưa thể áp điểm).',
          icon: 'info',
          buttonsStyling: false,
          confirmButtonText: 'Đã hiểu',
          customClass: { confirmButton: 'btn btn-primary' },
        })
        return
      }
      let idadDetails = this.dataAdm.adDetails[0]?.id
      let tempData = {
        idAdReg: this.admissionwinnerid,
        detail: this.dataPoints
      }
      await axios.put(`/admission/highschoolscore2/${idadDetails}`,tempData)
        .then(async({ data }) => {
          this.editAdmission(tempData.idAdReg)
        })
        .catch((error) => {
        });
    }
  },
  created() {
  },
  mounted() {
    this.admissionwinnerid = ''
  },
  setup() {
    const isAppraised = ref(false)
    const prScore = ref(0)
    const isCheckMajor = ref(false)
    const arrLabel = {
      "cccdtruoc": 'CCCD mặt trước',
      "cccdsau": 'CCCD mặt sau',
      "hocba10": 'Học bạ lớp 10',
      "hocba11": 'Học bạ lớp 11',
      "hocba12": 'Học bạ lớp 12',
      "khac": 'Giấy tờ khác',
    }
    
    const kt_modal_add_admissions_application = ref<null | HTMLElement>(null);
    const addCustomerModalRef = ref<null | HTMLElement>(null);
      
    const dataAdmissionRegister = ref<any>({})
    onMounted(async() => {
     
    });
    
    function popupLoading() {
       Swal.fire({
        html:"<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      }).then(() => {
        //
      });
    }
    const addRunAnalysis = ref<null | HTMLElement>(null);
    const call_modal_run_analysis = ref<any>();
    const tagAction = ref<any>(null);
      
    const dataPoints = ref<any>({})
    const arrSubject = {
      "Toán học": 'class12AverageMathScore',
      "Vật lí": 'class12AveragePhysicsScore',
      "Hóa học": 'class12AverageChemistryScore',
      "Sinh học": 'class12AverageBiologyScore',
      "Tin học": 'class12AverageInformationTechnologyScore',
      "Ngữ văn": 'class12AverageLiteratureScore',
      "Lịch sử": 'class12AverageHistoryScore',
      "Ngoại ngữ": 'class12AverageEnglishScore',
    }
    const credential = new AzureKeyCredential(key);
    const client = new DocumentAnalysisClient(
      endpoint,
      credential
    );
    const formData = ref<any>({
      fullName: '',
      idCard: '',
      dateOfBirth: '',
    })
    const admissionwinnerid = ref('')
    const dataFiles = ref<any>([])
    const imgActive = ref<any>('')
    const imgActiveFile = ref<any>(null)
    const dataAdm = ref<any>({})
      
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    return {
        call_modal_run_analysis,
        addRunAnalysis,
        admissionwinnerid,
        user,
        dataFiles,
        imgActive,
        imgActiveFile,
        tagAction,
        formData,
        client,
        popupLoading,
        dataPoints,
        arrSubject,
        dataAdm,
        dataAdmissionRegister,
        kt_modal_add_admissions_application,
        isAppraised,
        prScore,
        isCheckMajor,
        addCustomerModalRef,
        arrLabel,
    };
  },
});
